import { Marker, Tooltip } from 'react-leaflet'
import L from 'leaflet'
import { renderToString } from 'react-dom/server'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { DashboardAsset } from '../../../types/Dashboard'
import { getFlexTier, getAssetIcon } from '../../../utils/dashboardUtils'

type AssetMarkerProps = {
    asset: DashboardAsset
    onClick: () => void
}

const tierColors: Record<string, string> = {
    high: '#dc3545',
    medium: '#fd7e14',
    low: '#198754',
}

function createAssetDivIcon(asset: DashboardAsset): L.DivIcon {
    const tier = getFlexTier(asset.flexCapacityKw)
    const icon = getAssetIcon(tier)
    const color = tierColors[tier]

    const html = renderToString(
        <FontAwesomeIcon icon={icon} style={{ color, fontSize: '24px' }} />
    )

    return L.divIcon({
        html: `<div style="display:flex;align-items:center;justify-content:center">${html}</div>`,
        className: 'asset-marker-icon',
        iconSize: [32, 32],
        iconAnchor: [16, 16],
    })
}

export function AssetMarker({ asset, onClick }: AssetMarkerProps) {
    return (
        <Marker
            position={[asset.location.lat, asset.location.lng]}
            icon={createAssetDivIcon(asset)}
            eventHandlers={{ click: onClick }}
        >
            <Tooltip>{asset.name}</Tooltip>
        </Marker>
    )
}
